// services/totals.js — паричната аритметика на документите.
//
// Правило №6 от плана: парите се смятат с изрично закръгляне до стотинка —
// никога не се доверяваме на суров float. Тази логика живееше копирана в
// routes/invoices.js, routes/proformas.js и routes/protocols.js.

const { num } = require('../util');

// Закръгляне до 2 знака (стотинки), стабилно за float грешки (Number.EPSILON).
//
// СИМЕТРИЧНО около нулата (преглед 17.09.2026): Math.round мести половинката
// към +∞ — положителните отиваха навън (16.625 → 16.63), а отрицателните към
// нулата (−16.625 → −16.62). Така пълното сторно (кредитно известие) не
// нулираше фактурата си и оставяше стотинки да висят. Затова закръгляме
// АБСОЛЮТНАТА стойност както досега и връщаме знака после; +0 пази от „-0".
function round2(n) {
  const v = num(n, 0);
  const r = Math.round((Math.abs(v) + Number.EPSILON) * 100) / 100;
  return v < 0 ? (r === 0 ? 0 : -r) : r;
}

// Тотали на документ с редове. Ред без собствена ставка ползва ставката на
// документа (vatRate). Когато ВСИЧКИ редове са на една ставка, резултатът е
// точно както досега: закръглен сбор × ставка. При различни ставки (ПРОМТ-7)
// редовете се групират по ставка, за всяка група base = round2(Σ) и
// vat = round2(base × ставка), а сумите са сборове на групите. by_rate носи
// групите за Конто и OSS.
function lineRate(it, vatRate) {
  return (it && it.vat_rate !== undefined && it.vat_rate !== null && it.vat_rate !== '') ? num(it.vat_rate, 0) : num(vatRate, 0);
}

function computeTotals(items, vatRate) {
  const groups = [];
  for (const it of (Array.isArray(items) ? items : [])) {
    const rate = lineRate(it, vatRate);
    let g = groups.find((x) => x.rate === rate);
    if (!g) { g = { rate, sum: 0 }; groups.push(g); }
    g.sum += num(it.quantity, 0) * num(it.unit_price, 0);
  }
  if (!groups.length) groups.push({ rate: num(vatRate, 0), sum: 0 });
  const by_rate = groups.map((g) => {
    const base = round2(g.sum);
    return { rate: g.rate, base, vat: round2(base * (g.rate / 100)) };
  });
  const subtotal = round2(by_rate.reduce((s, g) => s + g.base, 0));
  const vat_amount = round2(by_rate.reduce((s, g) => s + g.vat, 0));
  return { subtotal, vat_amount, total: round2(subtotal + vat_amount), by_rate };
}

module.exports = { round2, computeTotals };
